// @theme component
export const MONTHS = [
    'playtech.mobile.system.month.January',
    'playtech.mobile.system.month.February',
    'playtech.mobile.system.month.March',
    'playtech.mobile.system.month.April',
    'playtech.mobile.system.month.May',
    'playtech.mobile.system.month.June',
    'playtech.mobile.system.month.July',
    'playtech.mobile.system.month.August',
    'playtech.mobile.system.month.September',
    'playtech.mobile.system.month.October',
    'playtech.mobile.system.month.November',
    'playtech.mobile.system.month.December'
];

export const NEVIS = 'nevis';

export enum PLAYER_NEVIS_TAG_VALUES {
    DEFAULT = 'default',
    COMPLETED = 'completed'
}
